/**
 * @fileoverview Agent definition for character-arc-extractor-v3.
 *
 * This agent analyzes source text to extract character arcs for major characters.
 * It is designed to run after character extraction, using the persisted character
 * data to know which characters to analyze.
 *
 * @category import.characters.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'character-arc-extractor-v3',
  kind: 'primitive',
  name: 'Character Arc Extractor',
  description: 'Extracts character arcs for major characters from source text.',
  category: 'characters',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'experimental',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'import.characters.extraction',
    usedBy: ['use-character-arc-extractor-v3'],
    usedInComposites: [],
    relatedAgents: [
      'character-extractor-full-v2',
      'character-arc-creation-v2',
    ],
  },
};
